// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"2082aabf","169":"31a20a1f","980":"93d82afc"}[chunkId] + ".chunk.js";
};